import { useTranslation } from 'react-i18next';
import { Row } from '@tanstack/react-table';
import Button from 'components/button/Button';
import PropertyEditActionWrapper from 'pages/property/common/PropertyEditActionWrapper';
import useOwnerModal from 'pages/property/owners/modals/ownerModal/useOwnerModal';
import useOwnerPermissionsModal from 'pages/property/owners/modals/ownerPermissionsModal/userOwnerPermissionsModal';
import useSendOwnerInviteModal from 'pages/property/owners/modals/sendOwnerInviteModal/useSendOwnerInviteModal';
import useRemovePropertyAccessModal from 'pages/property/owners/modals/removePropertyAccessModal/useRemovePropertyAccessModal';
import { TableItemOwner } from '../../../PropertySettingsOwnersTab.types';

const ActionsCell = ({ row }: { row: Row<TableItemOwner> }) => {
  const { t } = useTranslation();
  const { openEditOwnerModal } = useOwnerModal();
  const { openPermissionsModal } = useOwnerPermissionsModal();
  const { openSendOwnerInviteModal } = useSendOwnerInviteModal(row.original);
  const { openRemovePropertyAccessModal } = useRemovePropertyAccessModal();
  const ownerAlreadyClaimedAccess = !!row.original.lastLoginUtcDateTime;
  const shouldShowInviteButton =
    !ownerAlreadyClaimedAccess && !row.original.invitationSent;
  const shouldShowResendInviteButton =
    !ownerAlreadyClaimedAccess && row.original.invitationSent;

  return (
    <>
      <PropertyEditActionWrapper tooltipId="settings-button-tooltip">
        <Button
          bsStyle="link"
          data-testid="settings-button"
          onClick={() => openEditOwnerModal(row.original)}
        >
          {t('common.settings')}
        </Button>
      </PropertyEditActionWrapper>
      <Button
        bsStyle="link"
        data-testid="permissions-button"
        onClick={() => openPermissionsModal(row.original)}
      >
        {t('pageProperty.owners.permissions')}
      </Button>

      {shouldShowInviteButton && (
        <PropertyEditActionWrapper tooltipId="invite-button-tooltip">
          <Button
            bsStyle="link"
            data-testid="invite-button"
            onClick={() => openSendOwnerInviteModal()}
          >
            {t('pageProperty.owners.inviteOwner')}
          </Button>
        </PropertyEditActionWrapper>
      )}

      {shouldShowResendInviteButton && (
        <PropertyEditActionWrapper tooltipId="resend-invite-button-tooltip">
          <Button
            bsStyle="link"
            data-testid="resend-invite-button"
            onClick={() => openSendOwnerInviteModal()}
          >
            {t('pageProperty.owners.resendInvite')}
          </Button>
        </PropertyEditActionWrapper>
      )}

      <PropertyEditActionWrapper tooltipId="remove-button-tooltip">
        <Button
          bsStyle="link"
          data-testid="remove-button"
          onClick={() => openRemovePropertyAccessModal(row.original)}
        >
          {t('pageProperty.owners.removeOwner')}
        </Button>
      </PropertyEditActionWrapper>
    </>
  );
};

export default ActionsCell;
